<template>

<core-modal v-on:close="onClose" :nopadding="true" icon="caret-left">

	<template v-slot:head>

		<span>
			<template v-if="is.new">Add</template>
			<template v-if="!is.new">Edit</template>
			{{ type.lang.name }}
		</span>

		<small>{{ view.name }}</small>

	</template>

	<template v-slot:default>

		<template v-if="!model.locked && !isPlaceholder">

			<com-label v-model="model.label" v-if="hasSettingLabel" />
			<com-width v-model="model.width" v-if="hasSettingWidth" />
			<com-customwidth v-model="model.customwidth" v-if="hasSettingCustomWidth" />
			<com-sticky v-model="model.sticky" v-if="hasSettingSticky" />
			<com-devices v-model="model.devices" :view="view" :field="type" />
			<com-sorts v-model="model.sorts" :field="type" />
			<com-filters v-model="model.filters" :field="type" />

		</template>

		<template v-if="model.locked || isPlaceholder">

			<com-devices v-model="model.devices" :view="view" :field="type" />
			<com-sorts v-model="model.sorts" :field="type" />
			<com-filters v-model="model.filters" :field="type" />

		</template>

        <com-unique v-model="model[setting.key]" v-for="setting in unique" :setting="setting" :key="setting.key" />

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.saving" v-if="is.new">Add to view</core-button>
		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.saving" v-if="!is.new">Save changes</core-button>
		<core-button theme="red" v-on:click.native="onRemoveClick" :loading="is.removing" v-if="!is.new && !model.locked">Remove</core-button>

    </template>

</core-modal>

</template>

<script>

import $field from '@/field'

import comUnique from './field/Unique'
import comLabel from './field/Label'
import comWidth from './field/Width'
import comCustomwidth from './field/Customwidth'
import comSticky from './field/Sticky'
import comDevices from './field/Devices'
import comSorts from './field/Sorts'
import comFilters from './field/Filters'

export default {

    props: ['data'],

    components: {
        comUnique,
		comLabel,
		comWidth,
		comCustomwidth,
		comSticky,
		comDevices,
		comSorts,
		comFilters
    },

	data: function() {

		return {
			is: {
				new: true,
				saving: false,
				removing: false
			},
			model: {
				id: '',
				locked: 0,
                type: '',
				label: '',
				width: 'default',
				customwidth: 0,
				sticky: 0,
				devices: 0,
				sorts: [],
				filters: []
			}
		}

	},

	created: function() {

		if(this.data.model) {

			this.$vueset(this, 'model', this.$util.copy(this.data.model))

			this.is.new = false

		} else {

			this.model.type = this.data.type

			this.$_.each(this.type.default, function(value, key) {

				this.$vueset(this.model, key, value)

			}.bind(this))

		}

        this.$_.each(this.type.unique, function(setting) {

            if (this.model[setting.key] === undefined) {

                this.$vueset(this.model, setting.key, setting.default)

            }

        }.bind(this))

	},

    computed: {

        view: function() {

            return this.$_.find(this.$store.getters['data/views/list'], function(view) {

                return view.id === this.data.view

            }.bind(this))

        },

		isPlaceholder: function() {

			return this.type.placeholder || false

		},

		hasSettingLabel: function() {

			return this.view.type !== 4

		},

		hasSettingCustomWidth: function() {

			return this.model.width === 'custom'

		},

		hasSettingWidth: function() {

			return (this.view.type === 1 || this.view.type === 2) && !this.type.config.fixedWidth

		},

		hasSettingSticky: function() {

			return this.view.type === 1 || this.view.type === 2

		},

        unique: function() {

            var settings = []

            this.$_.each(this.type.unique, function(setting) {

				var visible = true

                if (setting.visibility) {

                    visible = setting.visibility(this.model, this.view)

                }

                if (setting.contexts && visible) {

                    visible = this.$_.contains(setting.contexts, this.$currentViewContext)

                }

				if (setting.views && visible) {

                    visible = this.$_.contains(setting.views, this.$currentViewType)

                }
				
				if (visible) settings.push(setting)

            }.bind(this))

            return settings

        },

        isValid: function() {

            return false

        },

        type: function() {

            return $field.type[this.model.type]

        }

    },

	methods: {

		onConfirmClick: function() {

			this.is.saving = true

			this.$api.post('views/field/save', {
				view: this.data.view,
				model: this.model
			}).then(function(response) {

				this.$store.commit('data/views/update', [response])

				if (this.is.new) {

					this.$store.commit('data/stash', {
						name: 'view/add',
						value: {
							search: '',
							type: '',
							scroll: 0
						}
					})

				}

				this.$pubsub.$emit('open.modal', {
					id: 'viewsView',
					view: this.data.view,
					model: this.model
				})

			}.bind(this))

		},

		onRemoveClick: function() {

			this.is.removing = true

			this.$api.post('views/field/remove', {
				view: this.data.view,
				model: this.model
			}).then(function(response) {

				this.$store.commit('data/views/update', [response])

				this.$pubsub.$emit('open.modal', {
					id: 'viewsView',
					view: this.data.view,
					model: this.model
				})

			}.bind(this))

		},

		onClose: function() {

			this.$pubsub.$emit('open.modal', {
                id: (this.data.model) ? 'viewsView' : 'viewsViewAdd',
                view: this.data.view
            })

		}

	}

}

</script>

<style scoped>

</style>